export default "__VITE_ASSET__Cvw1q5mV__"